import { useMutation } from '@tanstack/vue-query'

const useCreatePaymentLink = () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async () =>
      await $fetch<{ url: string }>('/api/payment-link', {
        query: {
          email: authStore.user?.email,
          name: `${authStore.user?.firstName} ${authStore.user?.lastName}`,
          id: authStore.user?.id,
          leadId: authStore.user?.leadId,
        },
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: ({ url }: { url: string }) => {
      navigateTo(url, {
        external: true,
      })
    },
  })
}

export default useCreatePaymentLink
